import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const options = { passive: true };
    this.element.addEventListener('focusin', this.update.bind(this), options);
    this.element.addEventListener('keyup', this.update.bind(this), options);
    this.element.addEventListener('keydown', this.update.bind(this), options);
    this.element.style.overflowY = 'hidden';
  }

  update() {
    this.element.style.height = '65px';
    this.element.style.height = this.element.scrollHeight + 'px';
  }
}
